import React from 'react'
import { BsLinkedin, BsGithub, BsInstagram } from 'react-icons/bs'
const HeaderSocials = () => {
    return (
        <div className='header__socials'>
            <a href='https://www.linkedin.com/in/saransh-gangwar-0b56161ba/' target='_blank' rel='noreferrer'>
                <BsLinkedin />
            </a>
            <a href='https://github.com/saransh79' target='_blank' rel='noreferrer'>
                <BsGithub />
            </a>
            <a href='https://instagram.com/saranshgangwar_?igshid=ZDdkNTZiNTM=' target='_blank' rel='noreferrer'>
                <BsInstagram />
            </a>
        </div>
    )
}

export default HeaderSocials